(() => {

  const toggles = document.querySelectorAll('[data-toggle="pagetop"]');
  if (!toggles) return; // ない場合はなにもしない

  // Scroll event
  toggles.forEach(pagetop => {
    window.addEventListener('scroll', (e) => {
      if (window.scrollY > 100) {
        pagetop.setAttribute('aria-disabled', 'false');
      } else {
        pagetop.setAttribute('aria-disabled', 'true');
        pagetop.setAttribute('aria-pressed', 'false');
      }
    });

    // Click event
    pagetop.onclick = () => {
      pagetop.setAttribute('aria-pressed', 'true');
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    };
  });

})();
